import React, {Component} from 'react';
import {Row, Col } from 'antd'
import './style.css'

export default class ExImage extends Component {
    render() {
        // console.log(this.props.images)
        return (
            <Row type="flex" justify="center" className="wrap-image">
                {this.props.images.map((image,index) => (
                    <Col key={index} md={{span:8}}>
                        <img src={image} alt="RunARAN-2017-ex"/>
                    </Col>
                ))}
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Login/ExImage.js